import { DefaultLayout } from "src/components/Layout"
import { useRouter } from "next/router"
import Head from "next/head"
import { NextPage } from "next"
import { useUsersListSWR } from "src/hooks/useUsersListSWR"
import { useState, useEffect } from "react"
import dayjs from "dayjs"
import { Users } from "src/features/user/components/User/users"

const UsersPage: NextPage = () => {
  const router = useRouter()
  const [currentPage, setCurrentPage] = useState(1)
  const [searchParams, setSearchParams] = useState("")

  // URLクエリパラメータから初期値を設定
  useEffect(() => {
    if (router.isReady) {
      const { page, params } = router.query
      if (page && typeof page === "string") {
        setCurrentPage(Number(page))
      }
      if (params && typeof params === "string") {
        setSearchParams(params)
      }
    }
  }, [router.isReady, router.query])

  // ユーザーデータを取得
  const { users, isLoading, error } = useUsersListSWR({
    page: currentPage,
    searchParams,
    limit: 300,
  })

  // 日付フォーマット処理
  const formatDate = (d: string) => dayjs(d).format("YYYY/MM/DD HH:mm:ss")

  const formattedUsers = users.map((user) => ({
    ...user,
    birthday: formatDate(user.birthday),
    createdAt: formatDate(user.createdAt),
    updatedAt: formatDate(user.updatedAt),
  }))

  // 検索機能
  const handleSearch = (newSearchParams: string) => {
    setSearchParams(newSearchParams)
    setCurrentPage(1) // 検索時はページを1に戻す

    // URLを更新
    const query: { [key: string]: string } = {}
    if (newSearchParams) {
      query.params = newSearchParams
    }
    router.push({
      pathname: "/admin/users",
      query,
    })
  }

  if (isLoading) {
    return (
      <DefaultLayout>
        <Head>
          <title>ユーザー一覧 | for CS</title>
        </Head>
        <div>loading...</div>
      </DefaultLayout>
    )
  }

  if (error) {
    return (
      <DefaultLayout>
        <Head>
          <title>ユーザー一覧 | for CS</title>
        </Head>
        <div>エラーが発生しました: {error.message}</div>
      </DefaultLayout>
    )
  }

  return (
    <DefaultLayout>
      <Head>
        <title>ユーザー一覧 | for CS</title>
      </Head>
      <Users users={formattedUsers} onSearch={handleSearch} isLoading={isLoading} />
    </DefaultLayout>
  )
}

export default UsersPage
